import * as React from "react";
import { useCallback } from "react";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
import { Col, Row, DataWell } from "common/components/layout-styles";
import { useGetDecoratedEventProcedure } from "security-app/hooks/useEventProceduresAPI";
import EventProcedureDetailsView from "../EventProcedureDetailsView";
function EventProcedureSummary({
  eventProcedureId,
  eventId = void 0,
  canEdit = false,
  onRemove = void 0,
  onEdit = void 0,
  row = false
}) {
  const { eventProcedure, loadingEventProcedure } = useGetDecoratedEventProcedure(eventProcedureId, eventId);
  const handleRemove = useCallback(() => onRemove == null ? void 0 : onRemove(), [onRemove]);
  const handleEdit = useCallback(() => onEdit == null ? void 0 : onEdit(), [onEdit]);
  if (loadingEventProcedure) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event Procedure" });
  return /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", { style: { whiteSpace: "break-spaces" } }, (eventProcedure == null ? void 0 : eventProcedure.title) || /* @__PURE__ */ React.createElement("i", null, "No title set")), /* @__PURE__ */ React.createElement(
    EventProcedureDetailsView,
    {
      eventProcedure,
      descriptionMaxHeight: row ? 400 : 250,
      row,
      eventId
    }
  ), canEdit && /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", bsStyle: "danger", onClick: handleRemove }, "Remove"), /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", bsStyle: "primary", onClick: handleEdit }, "Edit Event Procedure"))));
}
export default EventProcedureSummary;
